import dynamic from 'next/dynamic'
import { BlockProps } from '../BlockProps'
import { ISpecialistColumnsBlockData } from './ISpecialistColumnsBlockData'

export const DynamicSpecialistColumnsBlock = dynamic<
  BlockProps<ISpecialistColumnsBlockData>
>(() =>
  import('./SpecialistColumnsBlock').then((md) => md.SpecialistColumnsBlock)
)
